<template>
  <div id="details">

    <Head />
    <div class="details">
      <div class="head" @click="back()">
        <img src="../assets/Classroom/返回.png" />
        返回创新课程列表
      </div>
      <main>
        <div class="video">
          <!-- <video :src="video.Link" controls="controls"></video> -->
          <video-player v-if="video.Link" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
            :options="playerOptions"></video-player>
        </div>
        <div class="container">
          <p class="p1">{{ video.Classname }}</p>
          <p>{{ video.Publisher }}</p>
          <div style="margin-top: 0.2rem">播放次数：{{ video.Number }}次</div>
          <div v-if="!video.Publisher">视频来源于网上资源，不代表本站观点</div>
        </div>
      </main>
      <div class="recClass" v-if="list.length > 1">
        <p>其他课程</p>
        <div class="class">
          <div class="recommend" v-for="(item, index) in list" :key="index">
            <div class="curriculum" @click="toDetails(item.ID)">
              <div>
                <img :src="item.Image" />
              </div>
              <div>
                <div :title="item.Classname" class="cName">
                  {{ item.Classname }}
                </div>
                <div :title="item.Publisher" class="cName" style="color: #5d5d5d">
                  {{ item.Publisher }}
                </div>
                <div class="cDetails">
                  <div class="cName" style="color: #5d5d5d">
                    累计播放：{{ item.Number }}次
                  </div>
                  <div class="btn">学习</div>
                </div>

                <div>
                  <!-- <div>
                    <div>
                      <img src="../assets/Classroom/0.png" />
                      {{item.Zan}}
                    </div>
                    <div>
                      <img src="../assets/Classroom/1.png" />
                      {{item.Look}}
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";

export default {
  name: "CurriculumDetails",
  data() {
    return {
      playerOptions: {
        playbackRates: [], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      Recommend: [
        {
          Zan: 1658,
          Look: 4567,
          Name: "精益管理在膏体充填开采中的研究与应用",
          Img: require("../assets/Classroom/01.png"),
        },
        {
          Zan: 1658,
          Look: 4567,
          Name: "网络化安全管理生产企业中的创新与实践",
          Img: require("../assets/Classroom/02.png"),
        },
        {
          Zan: 1658,
          Look: 4567,
          Name: "煤炭施工企业“精用工”管控的实践和应用",
          Img: require("../assets/Classroom/03.png"),
        },
        {
          Zan: 1658,
          Look: 4567,
          Name: "“塔”式技能人才体系 力促轻型矿井建设",
          Img: require("../assets/Classroom/04.png"),
        },
      ],
      video: [],
      index: "",
      id: "",
      list: [],

      type: "",
    };
  },
  created() {
    console.log(this.$route.query.id);
    // (this.index = this.$route.query.index), (this.id = this.$route.query.id);
  },
  mounted() {
    this.getVoide();
    this.getRecommend();
  },
  inject: ["reload"],
  components: {
    Head,
    Foot,
  },
  props: {},
  methods: {
    toDetails(id) {
      // this.$axios
      //   .post(
      //     "classes/watchnums",
      //     this.$qs.stringify({
      //       ID: id,
      //       token: sessionStorage.getItem("token"),
      //     })
      //   )
      //   .then((res) => {
      //     console.log(res);
      //   });

      this.$router.push({
        path: "/CurriculumDetails",
        query: { id: id },
      });
      this.reload();
    },
    getRecommend() {
      if (
        this.$route.query.id == "13" ||
        this.$route.query.id == "14" ||
        this.$route.query.id == "15" ||
        this.$route.query.id == "16"
      ) {
        this.type = 2;
      } else if (
        this.$route.query.id == "17" ||
        this.$route.query.id == "18" ||
        this.$route.query.id == "19"
      ) {
        this.type = 3;
      } else if (
        this.$route.query.id == "25" ||
        this.$route.query.id == "26" ||
        this.$route.query.id == "27" ||
        this.$route.query.id == "28"
      ) {
        this.type = 5;
      } else if (this.$route.query.id == "29") {
        this.type = 6;
      } else if (this.$route.query.id == "30") {
        this.type = 7;
      } else if (this.$route.query.id == "31") {
        this.type = 8;
      } else {
        this.type = 4;
      }
      this.$axios
        .post(
          "classes/index",
          this.$qs.stringify({
            Type: this.type,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.list = res.data.data.list.slice(0, 4);
          }
        });
    },
    getVoide() {
      this.$axios
        .post(
          "classes/info",
          this.$qs.stringify({
            ID: this.$route.query.id,
            token: sessionStorage.token,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.video = res.data.data;
            this.playerOptions.sources[0].src = this.video.Link;
            this.playerOptions.poster = this.video.Image;
          }
        });
    },
    back() {
      this.$router.push("/Classroom");
    },
  },
};
</script>
<style lang="less" scoped>
.details {
  .video-js .vjs-icon-placeholder {
    width: 100%;
    height: 100%;
    display: block;
  }

  padding: 0 1.35rem;
  margin-top: 3.2rem;

  .head {
    font-size: 0.16rem;
    color: #313131;
    margin-bottom: 0.29rem;
    cursor: pointer;

    img {
      position: relative;
      top: 0.06rem;
      margin-right: 0.08rem;
    }
  }

  main {
    display: flex;

    .video {
      width: 7.82rem;
      height: 5.04rem;
    }

    .container {
      margin-left: 0.45rem;

      .p1 {
        font-size: 0.24rem;
        font-weight: bold;
        color: #2b2b2b;
        margin-bottom: 0.5rem;
      }

      div {
        font-size: 0.18rem;
        color: #4b4b4b;
      }
    }
  }

  .recClass {
    p {
      text-align: center;
      margin: 1rem 0 0.5rem;
      font-size: 0.24rem;
    }

    .class {
      display: flex;
      justify-content: space-around;

      .recommend {
        .curriculum {
          width: 3.25rem;
          margin-bottom: 0.3rem;
          border: 0.01rem solid #cbcbcb;
          border-radius: 0.1rem;
          cursor: pointer;

          >div:first-child {
            width: 100%;
            height: 2rem;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              display: block;
              border: 0.01rem solid #cbcbcb;
              border-top-left-radius: 0.1rem;
              border-top-right-radius: 0.1rem;
            }
          }

          >div:last-child {
            width: 100%;
            height: 1rem;
            line-height: 1.5;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0.05rem 0.1rem 0.1rem;
            position: relative;

            .cName {
              font-size: 0.16rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .cDetails {
              margin-top: 0.1rem;
              display: flex;
              font-size: 0.12rem;
              align-items: center;
              display: flex;
              justify-content: space-between;
              align-items: center;

              >div {
                display: flex;

                div {
                  display: flex;
                  align-items: center;
                  margin-right: 0.1rem;
                  color: #868686;

                  img {
                    width: 0.15rem;
                    height: 0.15rem;
                    margin-right: 0.05rem;
                  }
                }
              }

              .btn {
                padding: 0.05rem 0.15rem;
                color: #ffffff;
                background: #0556bc;
              }
            }
          }
        }
      }
    }
  }
}
</style>